import * as Blockly from "blockly";
import { zrCppGenerator } from "./generator/spheres/zrCppGenerator";


// ============================================================
// variables_array_get_pointer
// ============================================================

Blockly.Blocks["variables_array_get_pointer"] = {

    init: function () {

        this.setColour(330);

        this.appendDummyInput()
            .appendField("array pointer")
            .appendField(
                new Blockly.FieldTextInput("array"),
                "VAR"
            );

        this.setOutput(
            true,
            null
        );

        this.setTooltip(
            "Get a pointer to an array variable."
        );
    }
};


// ============================================================
// variables_array_get
// ============================================================

Blockly.Blocks["variables_array_get"] = {

    init: function () {

        this.setColour(330);

        this.appendValueInput("ARRAY")
            .appendField("get")
            .setCheck("array");

        this.appendValueInput("INDEX")
            .appendField("[")
            .setCheck("number");

        this.appendDummyInput()
            .appendField("]");

        this.setOutput(
            true,
            null
        );

        this.setTooltip(
            "Get an element from an array."
        );
    }
};


// ============================================================
// variables_array_declare
// ============================================================

Blockly.Blocks["variables_array_declare"] = {

    init: function () {

        this.setColour(330);

        this.appendDummyInput()
            .appendField("declare array")
            .appendField(
                new Blockly.FieldTextInput("array"),
                "VAR"
            );

        this.appendValueInput("SIZE")
            .appendField("size")
            .setCheck("number");

        this.setPreviousStatement(
            true,
            "declare"
        );

        this.setNextStatement(
            true,
            "declare"
        );

        this.setTooltip(
            "Declare an array variable."
        );
    }
};


// ============================================================
// variables_declare
// ============================================================

Blockly.Blocks["variables_declare"] = {

    init: function () {

        this.setColour(330);

        this.appendDummyInput()
            .appendField("declare")
            .appendField(
                new Blockly.FieldTextInput("variable"),
                "VAR"
            );

        this.appendValueInput("VALUE")
            .appendField("value");

        this.setPreviousStatement(
            true,
            "declare"
        );

        this.setNextStatement(
            true,
            "declare"
        );

        this.setTooltip(
            "Declare a variable."
        );
    }
};


// ============================================================
// variables_get
// ============================================================

Blockly.Blocks["variables_get"] = {

    init: function () {

        this.setColour(330);

        this.appendDummyInput()
            .appendField(
                new Blockly.FieldTextInput("variable"),
                "VAR"
            );

        this.setOutput(
            true,
            null
        );

        this.setTooltip(
            "Get a variable."
        );
    }
};


// ============================================================
// C++ generator:
// variables_array_get_pointer
// ============================================================

zrCppGenerator.forBlock[
    "variables_array_get_pointer"
] = function (block, generator) {

    const variable =
        block.getFieldValue("VAR") || "array";

    return [
        "&" + variable + "[0]",
        generator.ORDER_ATOMIC
    ];
};


// ============================================================
// C++ generator:
// variables_array_get
// ============================================================

zrCppGenerator.forBlock[
    "variables_array_get"
] = function (block, generator) {

    const array =
        generator.valueToCode(
            block,
            "ARRAY",
            generator.ORDER_ATOMIC
        ) || "array";

    const index =
        generator.valueToCode(
            block,
            "INDEX",
            generator.ORDER_ATOMIC
        ) || "0";

    return [
        array + "[" + index + "]",
        generator.ORDER_ATOMIC
    ];
};


// ============================================================
// C++ generator:
// variables_array_declare
// ============================================================

zrCppGenerator.forBlock[
    "variables_array_declare"
] = function (block, generator) {

    const variable =
        block.getFieldValue("VAR") || "array";

    const size =
        generator.valueToCode(
            block,
            "SIZE",
            generator.ORDER_ATOMIC
        ) || "0";

    return (
        "float " +
        variable +
        "[" +
        size +
        "];\n"
    );
};


// ============================================================
// C++ generator:
// variables_declare
// ============================================================

zrCppGenerator.forBlock[
    "variables_declare"
] = function (block, generator) {

    const variable =
        block.getFieldValue("VAR") || "variable";

    const value =
        generator.valueToCode(
            block,
            "VALUE",
            generator.ORDER_ATOMIC
        );

    if (value) {

        return (
            "float " +
            variable +
            " = " +
            value +
            ";\n"
        );
    }

    return (
        "float " +
        variable +
        ";\n"
    );
};


// ============================================================
// C++ generator:
// variables_get
// ============================================================

zrCppGenerator.forBlock[
    "variables_get"
] = function (block, generator) {

    const variable =
        block.getFieldValue("VAR") || "variable";

    return [
        variable,
        generator.ORDER_ATOMIC
    ];
};